import { Box } from '../../components/UI-CHAKRA/Box';
import { Flex } from '../../components/UI-CHAKRA/Flex';
import { Text } from '../../components/UI-CHAKRA/Text';
import { ReactComponent as SignatureIcon } from '../../assets/images/icons/mevo/ic-signature.svg';
import { Checkbox } from '../../components/UI-CHAKRA/Checkbox';
import { useState } from 'react';
import { Button } from '../../components/UI-CHAKRA/Button';
import { ReactComponent as RightArrow } from '../../assets/images/icons/right-arrow.svg';

export enum JustificationOptions {
  PatientRequest = 'Paciente solicitou a impressão.',
  PatientNoConection = 'Paciente não tem acesso à internet ou celular.',
  MandatoryForm = 'Formulário específico para a rede, de preenchimento obrigatório.',
  DigitalCertificateUnavailable = 'Instabilidade do certificado digital.',
}

type PrintJustifyDialogProps = {
    onClose: () => void;
    onSubmit: (justification: JustificationOptions) => void;
  };
const PrintJustifyDialog = (props: PrintJustifyDialogProps) => {
  const [selectedCheckbox, setSelectedCheckbox] = useState<string>('');
  const justificationOptionsArray: string[] = Object.values(JustificationOptions);

  return (
    <Box p={6} bg="white" borderRadius="20px" boxShadow="md">
      <Flex direction={'column'} gap={'10px'}>
        <Flex direction={'row'} gap={'20px'}>
          <SignatureIcon />
          <Text fontWeight={700} color={'#1e252b'} fontSize={'14px'}>
            Atenção! <br />
            Gostaríamos de entender por que optou pela impressão da prescrição. <br />
            Justifique sua decisão selecionando uma das opções abaixo:
          </Text>
        </Flex>
        <Flex direction={'column'} gap={'10px'} mt={'20px'} ml={'20px'}>
          {justificationOptionsArray.map((option, index) => (
            <Box key={index}>
              <Checkbox
                value={option}
                isChecked={selectedCheckbox === option}
                onChange={(e) => setSelectedCheckbox(e.target.value)}
              >
                <Text fontSize={'14px'} color="#3d0e6b">
                  {option}
                </Text>
              </Checkbox>
            </Box>
          ))}
        </Flex>
        <Box width={'100%'} textAlign={'right'}>
          <Button rightIcon={<RightArrow />} type={'submit'} isDisabled={!selectedCheckbox} borderRadius={'40px'} onClick={() => props.onSubmit(selectedCheckbox as JustificationOptions)}>
            Concluir
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default PrintJustifyDialog;
